import DoAPICall from './DoAPICall'

//Create PaymentsProvider
    export async function createPaymentsProvider(userToken, paymentsProvider){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'paymentsproviders',
            payLoad:{
                shortname:paymentsProvider.shortname,
                name:paymentsProvider.name,
                colour:paymentsProvider.colour,
                contactName:paymentsProvider.contactName,
                contactEmail:paymentsProvider.contactEmail,
                contactNo:paymentsProvider.contactNo,
                logo:paymentsProvider.logo
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Payments Providers
    export async function getPaymentsProviders(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'paymentsproviders',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Payments Provider
    export async function getPaymentsProvider(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'paymentsproviders/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Payments Provider
    export async function updatePaymentsProvider(userToken, paymentsProvider){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'paymentsproviders/'+paymentsProvider.id,
            payLoad:{
                shortname:paymentsProvider.shortname,
                name:paymentsProvider.name,
                colour:paymentsProvider.colour,
                contactName:paymentsProvider.contactName,
                contactEmail:paymentsProvider.contactEmail,
                contactNo:paymentsProvider.contactNo,
                logo:paymentsProvider.logo
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete PaymentsProvider (by updating the status)



  